/* eslint-disable */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import CommonTextField from '../../../Components/TextField/textField';
import FormDialog from '../../../Components/Modal/modal';
import SearchDropdown from '../../../Components/Dropdown/dropdown';
import './addEditStaffAugStatusMaster.scss';
import {
  ADD_EDIT_STAFF_AUG_STATUS,
  CANCEL_TEXT,
  SAVE,
  UPDATE,
} from '../../../Constants/strings';
import { ColorSelection } from '../../../Components/ColorPicker/index.js';
import { useSnackbar } from '../../../Components/Snackbar/snackBarProvider.js';
import { handleApiResponse, saveOrUpdateStatus } from './addEditUtil.js';

const AddEditStaffAugStatusForm = ({
  modalOpen,
  handleClose,
  setRows,
  isEditMode,
  statusId,
  initialStatusName,
  initialDescription,
  initialColor,
  initialReason,
  lastUpdatedBy,
  isActive,
  statusCategory,
  getStaffAugStatusData,
  getLostDroppedStatusData,
  setIsPickerVisible,
  selectedStatusColor,
  isPickerVisible,
  existingColors,
  existingStatusNames,
  existingReasons,
  isMapped,
}) => {
  const [statusName, setStatusName] = useState(initialStatusName || '');
  const [statusDescription, setStatusDescription] = useState(initialDescription || '');
  const [statusColor, setStatusColor] = useState(selectedStatusColor || '');
  const [reason, setReason] = useState(initialReason || '');
  const [statusNameError, setStatusNameError] = useState('');
  const [descriptionError, setDescriptionError] = useState('');
  const [colorError, setColorError] = useState('');
  const [statusReasonError, setStatusReasonError] = useState('');
  const [isModified, setIsModified] = useState(false); // Track if changes were made
  const { snackbarOpen } = useSnackbar();

  const lostDroppedOptions = [
    { name: 'Lost', value: 'Lost' },
    { name: 'Dropped', value: 'Dropped' },
  ];
  const geographyTypes = [
    { name: 'Global', value: 'Global' },
    { name: 'Domestic', value: 'Domestic' },
  ];
  useEffect(() => {
    setInitialValues();
  }, [initialStatusName, initialDescription, initialReason, modalOpen]);

  useEffect(() => {
    setStatusColor(selectedStatusColor || '');
  }, [selectedStatusColor, initialColor]);

  useEffect(() => {
    if (colorError && statusColor) {
      setColorError('');
    }
  }, [statusColor, statusName, statusDescription]);

  useEffect(() => {
    if (statusCategory === 'lost-dropped-status') {
      setIsModified(
        statusName !== initialStatusName
        || reason !== initialReason
        || statusDescription !== initialDescription,
      );
    } else if (statusCategory === 'geography') {
      setIsModified(
        statusName.trim() !== '' || statusDescription.trim() !== '',
      );
    } else {
      setIsModified(
        statusName !== initialStatusName
        || statusDescription !== initialDescription
        || statusColor !== initialColor,
      );
    }
  }, [
    statusName,
    statusDescription,
    statusColor,
    reason,
    initialStatusName,
    initialDescription,
    initialColor,
    initialReason,
    statusCategory,
  ]);

  const setInitialValues = () => {
    setStatusName(initialStatusName || '');
    setStatusDescription(initialDescription || '');
    setStatusColor(initialColor || '');
    setReason(initialReason || '');
  };

  const resetValues = () => {
    setStatusName('');
    setStatusDescription('');
    setStatusColor('');
    setReason('');
    setStatusNameError('');
    setDescriptionError('');
    setColorError('');
    setStatusReasonError('');
    setIsModified(false); // Reset the modified state
  };

  const handleCloseWithReset = () => {
    resetValues();
    handleClose();
  };

  const handleResponse = (responseData) => {
    handleApiResponse({
      responseData,
      isEditMode,
      updateRowsWithEditedStatus,
      getStaffAugStatusData,
      getLostDroppedStatusData,
      snackbarOpen,
      handleCloseWithReset,
      isLostDroppedStatus: statusCategory === 'lost-dropped-status',
      statusCategory,
    });
  };

  const updateRowsWithEditedStatus = (statusIdVal) => {
    setRows((prevRows) =>
      prevRows.map((row) => (
        row.id === statusIdVal
          ? { ...row, statusName, statusDescription, statusColor, reason }
          : row
      )));
  };

  const handleInputChange = (event) => {
    const { id, value } = event.target;

    if (id === 'staff-status-master-name') {
      setStatusName(value);
      validateStatusName(value);
    } else if (id === 'staff-status-master-description') {
      setStatusDescription(value);
      validateDescription(value);
    } else if (id === 'staff-status-reason') {
      setReason(value);
      validateReason(value);
    } else if (id === 'staff-status-master-dropdown') {
      setStatusName(value);
      validateDropdownStatusName(value);
    }
  };

  const validateStatusName = (value) => {
    const regex = /^[A-Za-z\s]+$/;
    if (value.length < 2 || value.length > 20) {
      setStatusNameError(ADD_EDIT_STAFF_AUG_STATUS.STATUS_NAME_MUST_BE);
    } else if (!regex.test(value)) {
      setStatusNameError(ADD_EDIT_STAFF_AUG_STATUS.STATUS_NAME_INVALID);
    } else {
      setStatusNameError('');
    }
  };

  const validateDropdownStatusName = (value) => {
    if (!value) {
      setStatusNameError(ADD_EDIT_STAFF_AUG_STATUS.STATUS_NAME_REQUIRED_FIELD);
    } else {
      setStatusNameError('');
    }
  };

  const validateDescription = (value) => {
    if (value && (value.length < 2 || value.length > 250)) {
      const isGeography = statusCategory === 'geography';
      const label = isGeography ? 'Name' : 'Description';
      setDescriptionError(`${label} must be 2 to 250 characters long`);
    } else {
      setDescriptionError('');
    }
  };


  const validateReason = (value) => {
    if (value.length < 2 || value.length > 250) {
      setStatusReasonError(ADD_EDIT_STAFF_AUG_STATUS.REASON_MUST_BE);
    } else if (!value.trim()) {
      setStatusReasonError(ADD_EDIT_STAFF_AUG_STATUS.REASON_REQUIRED_FIELD);
    } else {
      setStatusReasonError('');
    }
  };

  const validateUniqueReason = () => {
    if (
      Array.isArray(existingReasons)
      && existingReasons.includes(reason)
      && reason !== initialReason
    ) {
      setStatusReasonError(ADD_EDIT_STAFF_AUG_STATUS.REASON_ALREADY_EXISTS);
      snackbarOpen(ADD_EDIT_STAFF_AUG_STATUS.REASON_ALREADY_EXISTS, 'error');
      return false;
    }
    setStatusReasonError('');
    return true;
  };

  const handleSaveOrUpdate = async () => {   
    if (statusCategory === 'geography') {
      if (!validateRequiredFields()) return;
      const payload = createPayload();
      await saveOrUpdateStatus({
      payload,
      isEditMode,
      handleResponse,
      snackbarOpen,
      statusCategory,
    });
    return; 
  }

    if (statusNameError || colorError || statusReasonError || descriptionError) return;
    if (!validateRequiredFields()) return;
    if (statusCategory === 'lost-dropped-status' && !validateReasonField()) return;
    if (!validateUniqueStatusName()) return;
    if (!validateUniqueReason()) return;
    if (statusCategory !== 'lost-dropped-status' && !validateUniqueColor()) return;

    const payload = createPayload();

    await saveOrUpdateStatus({
      payload,
      isEditMode,
      isActive,
      lastUpdatedBy,
      handleResponse,
      snackbarOpen,
      isLostDroppedStatus: statusCategory === 'lost-dropped-status',
    });
  };


  const validateRequiredFields = () => {
    let isValid = true;

    if (statusCategory === 'geography') {
      if (!statusName) {
        setStatusNameError('Type is required');
        isValid = false;
      }
      if (!statusDescription) {
        setDescriptionError('Name is required');
        isValid = false;
      }
      return isValid;
    }

    if (!statusName) {
      setStatusNameError(ADD_EDIT_STAFF_AUG_STATUS.STATUS_NAME_REQUIRED_FIELD);
      isValid = false;
    }

    if (statusCategory !== 'lost-dropped-status' && !statusDescription) {
      setDescriptionError(ADD_EDIT_STAFF_AUG_STATUS.DESCRIPTION_REQUIRED_FIELD);
      isValid = false;
    }

    if (statusCategory !== 'lost-dropped-status' && !statusColor) {
      setColorError(ADD_EDIT_STAFF_AUG_STATUS.COLOR_REQUIRED_FIELD);
      isValid = false;
    }

    if (statusCategory === 'lost-dropped-status' && !reason) {
      setStatusReasonError(ADD_EDIT_STAFF_AUG_STATUS.REASON_REQUIRED_FIELD);
      isValid = false;
    }

    return isValid;
  };


  const validateReasonField = () => {
    if (!reason) {
      setStatusReasonError(ADD_EDIT_STAFF_AUG_STATUS.REASON_REQUIRED_FIELD);
      return false;
    }
    setStatusReasonError('');
    return true;
  };

  const validateUniqueStatusName = () => {
    if (
      statusCategory !== 'lost-dropped-status'
      && Array.isArray(existingStatusNames)
      && existingStatusNames.includes(statusName)
      && statusName !== initialStatusName
    ) {
      setStatusNameError(ADD_EDIT_STAFF_AUG_STATUS.STATUS_NAME_ALREADY_EXISTS);
      snackbarOpen(ADD_EDIT_STAFF_AUG_STATUS.STATUS_NAME_ALREADY_EXISTS, 'error'); // Show snackbar with error message
      return false;
    }
    return true;
  };

  // Check if status color already exists with any other status

  const validateUniqueColor = () => {
    const colorExistsWithOtherStatus = existingColors.some(
      (color, index) =>
        color === statusColor && existingStatusNames[index] !== initialStatusName,
    );

    if (colorExistsWithOtherStatus) {
      setColorError(ADD_EDIT_STAFF_AUG_STATUS.COLOR_ALREADY_EXISTS);
      snackbarOpen(ADD_EDIT_STAFF_AUG_STATUS.COLOR_ALREADY_EXISTS, 'error');
      return false;
    }
    return true;
  };

  const sanitizeInput = (value) => {
    return String(value || '').trim();
  };
  const createPayload = () => {
    if (statusCategory === 'lost-dropped-status') {
      return {
        statusId,
        statusName,
        statusDescription,
        reason,
      };
    }
    if (statusCategory === 'geography') {
      if (isEditMode && (!statusId || typeof statusId !== 'number')) {
        return null;
      }
      return {
        geographyId: statusId,
        geographyType: sanitizeInput(statusName),
        geographyPlace: sanitizeInput(statusDescription),
        lastUpdatedBy,
      };
  }
    return {
      statusId,
      statusName,
      statusDescription,
      statusColor,
      statusCategory,
    };


  };

  return (
    <div>
      <FormDialog
        title={
          statusCategory === 'geography'
            ? isEditMode
              ? 'Edit Geography'
              : 'Add Geography'
            : isEditMode
              ? ADD_EDIT_STAFF_AUG_STATUS.EDIT_STATUS
              : ADD_EDIT_STAFF_AUG_STATUS.ADD_STATUS
        }
        open={modalOpen}
        button1Action={handleCloseWithReset}
        button2Action={handleSaveOrUpdate}
        dialogPaperCss='staff-aug-status-dialog-paper'
        dialogCss='staff-aug-status-dialog'
        dialogBodycontent={
          <div className='staff-aug-status-dialog-body'>
            {statusCategory === 'geography' ? (
              <>
                <SearchDropdown
                  searchBox={false}
                  label="Deal type*"
                  options={geographyTypes}
                  value={statusName}
                  placeholder="Select Deal type"
                  onChange={(event) =>
                    handleInputChange({
                      target: {
                        id: 'staff-status-master-dropdown',
                        value: event.target.value.value,
                      },
                    })
                  }
                  dropdownCss='status-dropdown'
                  disabled={isMapped}
                />
                {statusNameError && (
                  <div className='status-error'>
                    <small>{statusNameError}</small>
                  </div>
                )}
                <div className='status-description'>
                  <CommonTextField
                    textCss='staff-status-description'
                    label="Name*"
                    value={statusDescription}
                    onChange={handleInputChange}
                    placeholder="Enter geography name"
                    size='small'
                    id='staff-status-master-description'
                    name='statusDescription'
                    multiline
                    disabled={isMapped}
                  />
                  {descriptionError && (
                    <div className='status-error'>
                      <small>{descriptionError}</small>
                    </div>
                  )}
                </div>
              </>
            ) : statusCategory === 'lost-dropped-status' ? (
              <>
                <SearchDropdown
                  searchBox={false}
                  label={ADD_EDIT_STAFF_AUG_STATUS.STATUS_NAME}
                  options={lostDroppedOptions}
                  value={statusName}
                  placeholder={ADD_EDIT_STAFF_AUG_STATUS.STATUS_NAME_SELECT_PLACEHOLDER}
                  onChange={(event) =>
                    handleInputChange({
                      target: {
                        id: 'staff-status-master-dropdown',
                        value: event.target.value.value,
                      },
                    })
                  }
                  dropdownCss='status-dropdown'
                  disabled={isMapped}
                />
                {statusNameError && (
                  <div className='status-error'>
                    <small>{statusNameError}</small>
                  </div>
                )}
                <div className='status-reason'>
                  <CommonTextField
                    label={ADD_EDIT_STAFF_AUG_STATUS.REASON}
                    value={reason}
                    onChange={handleInputChange}
                    placeholder={ADD_EDIT_STAFF_AUG_STATUS.REASON_PLACEHOLDER}
                    size='small'
                    id='staff-status-reason'
                    name='statusReason'
                    disabled={isMapped}
                  />
                  {statusReasonError && (
                    <div className='status-error'>
                      <small>{statusReasonError}</small>
                    </div>
                  )}
                </div>
              </>
            ) : (
              <>
                <CommonTextField
                  label={ADD_EDIT_STAFF_AUG_STATUS.STATUS_NAME}
                  value={statusName}
                  onChange={handleInputChange}
                  placeholder={ADD_EDIT_STAFF_AUG_STATUS.STATUS_NAME_PLACEHOLDER}
                  autoFocus
                  size='small'
                  id='staff-status-master-name'
                  name='statusName'
                  disabled={isMapped}
                />
                {statusNameError && (
                  <div className='status-error'>
                    <small>{statusNameError}</small>
                  </div>
                )}
              </>
            )}
            {statusCategory !== 'geography' && (
              <>
                <div className='status-description'>
                  <CommonTextField
                    textCss='staff-status-description'
                    label={
                      statusCategory === 'lost-dropped-status'
                        ? ADD_EDIT_STAFF_AUG_STATUS.LOST_DROPPED_STATUS_DESCRIPTION
                        : ADD_EDIT_STAFF_AUG_STATUS.DESCRIPTION
                    }
                    value={statusDescription}
                    onChange={handleInputChange}
                    placeholder={ADD_EDIT_STAFF_AUG_STATUS.DESCRIPTION_PLACEHOLDER}
                    size='small'
                    id='staff-status-master-description'
                    name='statusDescription'
                    multiline
                    rows={4}
                  />
                  {descriptionError && (
                    <div className='status-error'>
                      <small>{descriptionError}</small>
                    </div>
                  )}
                </div>

                {statusCategory !== 'lost-dropped-status' && (
                  <div className='status-color'>
                    <ColorSelection
                      setIsPickerVisible={setIsPickerVisible}
                      pickedColor={statusColor}
                    />
                    {colorError && (
                      <div className='status-error'>
                        <small>{colorError}</small>
                      </div>
                    )}
                  </div>
                )}
              </>
            )}
          </div>
        }
        button1={CANCEL_TEXT}
        button2={isEditMode ? UPDATE : SAVE}
        cancelButtonId='status-cancel-btn'
        submitButtonId='status-submit-btn'
        button2Disabled={!isModified} // Disable the button if no changes were made
      />
      {isPickerVisible && <div className='staff-aug-status-add-edit-overlay' />}
    </div>
  );
};

AddEditStaffAugStatusForm.propTypes = {
  modalOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  setRows: PropTypes.func.isRequired,
  isEditMode: PropTypes.bool,
  statusId: PropTypes.number,
  initialStatusName: PropTypes.string,
  initialDescription: PropTypes.string,
  initialColor: PropTypes.string,
  initialReason: PropTypes.string,
  lastUpdatedBy: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
  statusCategory: PropTypes.string.isRequired,
  getStaffAugStatusData: PropTypes.func.isRequired,
  getLostDroppedStatusData: PropTypes.func.isRequired,
  setIsPickerVisible: PropTypes.func.isRequired,
  selectedStatusColor: PropTypes.string,
  isPickerVisible: PropTypes.bool.isRequired,
  existingColors: PropTypes.array.isRequired,
  existingStatusNames: PropTypes.array.isRequired,
  existingReasons: PropTypes.array.isRequired,
  isMapped: PropTypes.bool.isRequired,
};

AddEditStaffAugStatusForm.defaultProps = {
  isEditMode: false,
  statusId: null,
  initialStatusName: '',
  initialDescription: '',
  initialColor: '',
  initialReason: '',
  isActive: true,
  selectedStatusColor: [],
};

export default AddEditStaffAugStatusForm;
